import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { ANIMATION_FUNCTION, IconButton } from "@similarweb/ui-components";

import { FILTER_CARD_ANIMATION_DURATION } from "../../constants";

export const StyledFilterItemCollapseIconWrapper = styled.span<{ isExpanded: boolean }>`
    transform: rotate(${({ isExpanded }) => (isExpanded ? 180 : 0)}deg);
    transition: all ${FILTER_CARD_ANIMATION_DURATION}ms ${ANIMATION_FUNCTION};
`;

export const StyledFilterItemCardExpandButton = styled(IconButton)`
    ${SWReactIcons} {
        & svg path {
            fill: ${colorsPalettes.bluegrey[600]};
        }
    }
`;
